export const getPath = path => {
  if (path) {
    if (process.env.NODE_ENV === 'production') {
      return `${process.env.REACT_APP_PATH}${path}`;
    }

    return path.replace('public/', '/');
  }

  return path;
};
